import { Button } from '@platform/ui-library';
import { FormEvent, useState } from 'react';
import { Input } from '@app/form_components';
import styles from './AddForm.module.scss';

type AddFormProps<T extends string> = {
  className?: string;
  disabled?: boolean;
  label?: string;
  onSubmit: (item: string) => void;
  placeholder?: string;
  type: T;
};

export default function AddForm<T extends string = string>(props: AddFormProps<T>) {
  const inputName = `${props.type}Name`;
  const [value, setValue] = useState('');

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!value) {
      return;
    }
    props.onSubmit(value);
    setValue('');
  };

  return (
    <form onSubmit={onSubmit} className={`${styles.container} ${props.className || ''}`}>
      {/* TODO: This should be an autocomplete [?] */}
      <Input
        className={styles.containerInput}
        disabled={props.disabled}
        extraClasses={styles.containerInputWrapper}
        fieldConfig={{ className: styles.containerInputOutterWrapper }}
        label={props.label ?? ''}
        name={inputName}
        onChange={setValue}
        placeholder={props.placeholder || `Add ${props.type}`}
        required
        value={value}
      />
      <Button
        type="submit"
        tabIndex={-1}
        disabled={props.disabled}
        icon="plus"
        theme={['outline', 'round', 'small']}
      />
    </form>
  );
}
